import { render, staticRenderFns } from "./KidAnalytics.vue?vue&type=template&id=90367126&scoped=true"
import script from "./KidAnalytics.vue?vue&type=script&lang=js"
export * from "./KidAnalytics.vue?vue&type=script&lang=js"
import style0 from "./KidAnalytics.vue?vue&type=style&index=0&id=90367126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90367126",
  null
  
)

export default component.exports